<script setup lang="ts">
import { ref } from 'vue';
import { TopButton } from '@/components/forms/forms';
import type { Emits, Props } from '@/components/formsExt/policy/types';

defineProps<Props>();
const emits = defineEmits<Emits>();

const isVisible = ref(true);

const onAccept = () => {
	isVisible.value = false;

	emits('accept');
};
</script>

<template>
	<div
		v-if="isVisible"
		class="top-policy"
	>
		<div class="top-policy_title">
			{{ title }}
		</div>

		<div
			class="top-policy_description"
			v-html="description"
		></div>

		<TopButton
			size="m"
			@click="onAccept"
		>
			{{ acceptText }}
		</TopButton>
	</div>
</template>

<style>
.top-policy {
	box-sizing: border-box;
	box-shadow: var(--top-shadow-b);
	border-radius: var(--top-radius-4);
	background: var(--color-bg-lightning-1);
	width: 600px;
	padding: var(--top-padding-4);
	position: fixed;
	right: var(--top-gap-10);
	bottom: var(--top-gap-10);
	display: flex;
	flex-direction: column;
	gap: var(--top-gap-4);
	z-index: 10000;
}

.top-policy_title {
	font-size: 24px;
	font-weight: 700;
}

.top-policy_description {
	font-size: 14px;
}

@media screen and (max-width: 900px) {
	.top-policy {
		width: 100%;
		right: 0;
		bottom: calc(var(--top-gap-5) + var(--toolbar-height, 0px));
	}
}
</style>
